export default "__VITE_ASSET__BcWQ1t____"